import moment from "moment";
import { useCallback, useMemo } from "react";
import { useController, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { DateField } from "../../../../../components/forms/date";
import { validationFields } from "../../../../common/models/fields";
import { Field } from "../../internal/field";
import { FieldHook, RenderFuncProps } from "../common";

const Elem = ({ item }: RenderFuncProps) => {
  const dobName = validationFields.dateOfBirth.useName();
  const { control } = useFormContext();
  const {
    field,
    fieldState: { error },
  } = useController({
    control,
    name: item.field,
  });

  return (
    <>
      <div>{dobName}</div>
      <DateField
        {...field}
        fullWidth
        error={!!error}
        helperText={error?.message}
        autoComplete="bday"
      />
    </>
  );
};

const useSchema = () => {
  const { t } = useTranslation("fields");
  const dobSchemaFn = validationFields.dateOfBirth.useSchema();
  return useMemo(
    () =>
      dobSchemaFn.max(
        moment().subtract(18, "years").toDate(),
        t("you-must-be-at-least-18-years-old")
      ),
    [t, dobSchemaFn]
  );
};

export const useDobField: FieldHook = () => {
  const schema = useSchema();
  return useMemo(
    () => ({
      schema,
      elem: Elem,
    }),
    [schema]
  );
};
